import React, { useRef } from 'react';
var VeltMultiThreadCommentDialogResetFilterButton = function (props) {
    var annotationId = props.annotationId, multiThreadAnnotationId = props.multiThreadAnnotationId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-multi-thread-comment-dialog-reset-filter-button", { ref: ref, "annotation-id": annotationId, "multi-thread-annotation-id": multiThreadAnnotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltMultiThreadCommentDialogResetFilterButton;
